import { DWTableCellImg } from 'src/components/table-cell-img';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWTableCellImg.displayName, DWTableCellImg);

export default DWTableCellImg;

export { DWTableCellImg };
